import React from 'react';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';

const BrandSelector = ({ 
  brands, 
  selectedBrand, 
  onBrandChange, 
  error 
}) => {
  const brandOptions = brands?.map(brand => ({
    value: brand?.id,
    label: brand?.name,
    description: `${brand?.cashbackPercentage}% cashback • Cap: $${brand?.rewardCap}`
  }));

  const selectedBrandData = brands?.find(b => b?.id === selectedBrand);

  return (
    <div className="space-y-4">
      <Select
        label="Select Brand Partner"
        description="Choose from active campaign partners"
        placeholder="Select a brand..."
        options={brandOptions}
        value={selectedBrand}
        onChange={onBrandChange}
        error={error}
        required
        searchable
      />
      {selectedBrandData && (
        <div className="bg-gradient-to-r from-primary/10 to-secondary/10 rounded-xl p-4 md:p-6 border border-primary/20">
          <div className="flex items-start gap-3 md:gap-4">
            <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-primary/20 flex items-center justify-center flex-shrink-0">
              <Icon name="Tag" size={20} color="var(--color-primary)" />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-base md:text-lg font-semibold text-foreground mb-1">
                {selectedBrandData?.name}
              </h3>
              <p className="text-xs md:text-sm text-muted-foreground mb-3">
                {selectedBrandData?.category}
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                <div className="flex items-center gap-2">
                  <Icon name="Percent" size={16} color="var(--color-success)" />
                  <span className="text-sm md:text-base font-medium text-success">
                    {selectedBrandData?.cashbackPercentage}% Cashback
                  </span>
                </div>
                <div className="flex items-center gap-2">
                  <Icon name="DollarSign" size={16} color="var(--color-warning)" />
                  <span className="text-sm md:text-base font-medium text-warning">
                    Max ${selectedBrandData?.rewardCap}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BrandSelector;